import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type { MailThread } from "../../managers/mail/types/mail";

export type MailThreads = {
    getMailThread: (uniqueMailvistaId: string) => Promise<MailThread>;
    getMailFullBodyContentWithAttachments: (
        internetMessageId: string,
    ) => Promise<void>;
};

/** Lecture des fils ; les ajouts et enrichissements arrivent par `thread-updated` et `mail-updated`. */
export function useMailThreads(): MailThreads {
    const { mailManager } = useSdk();

    return useMemo<MailThreads>(
        () => ({
            getMailThread: (...args) => mailManager.getMailThread(...args),
            getMailFullBodyContentWithAttachments: (...args) =>
                mailManager.getMailFullBodyContentWithAttachments(...args),
        }),
        [mailManager],
    );
}
